import React from 'react'
import Milestones from './Milestones'
// import Iso from './Iso'

function About() {
    // const styles = {
    //     container1: {
    //         textAlign: 'center',
    //     },
    //     header1: {
    //         padding: '10px',
    //     },
    //     title1: {
    //         fontSize: '40px',
    //         marginTop: '140px'
    //     },
    //     imageContainer: {
    //         marginTop: '10px',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //     },
    //     imageStyle: {
    //         maxWidth: '80%',
    //         height: 'auto',
    //         backgroundColor: 'white',
    //     },
    //     '@media (max-width: 768px)': {
    //         imageStyle: {
    //             maxWidth: '95%',
    //         },
    //     },

    // }
    return (
        <div>
            <section className="page-header-section page-header-colored" style={{ marginTop: "10vh" }}>
                <div className="container">
                    <div className="page-header-wrapper">
                        <div className="page-header-content">
                            <div className="page-title">
                                <h1>About</h1>
                            </div>
                            <div className="breadcrumbs">
                                <ul>
                                    <li>
                                        <a  href='/'> Home </a>
                                    </li>

                                    <li>About</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <div className="vision-container">
      <div className="vision-header">
        <h2>OUR VISION</h2>
      </div>
      
      <div className="vision-content">
        <p>
          TO MANUFACTURE ZERO DEFECT COMPONENTS WITH CONTROLLED MANUFACTURING PROCESS AND CONTINUOUS IMPROVEMENT IN QUALITY SYSTEMS
        </p>
      </div>

      <style>{`
        .vision-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
        }

        .vision-header {
          background: linear-gradient(to right, #f59e0b, #ff7800);
          color: white;
          padding: 8px 16px;
          border-radius: 6px;
          width: fit-content;
          margin-bottom: 16px;
        }

        .vision-header h2 {
          font-size: 20px;
          font-weight: bold;
          margin: 0;
        }

        .vision-content {
          background-color: #ff7800;
          padding: 32px;
          border-radius: 16px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .vision-content p {
          color: white;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          line-height: 1.5;
          margin: 0;
        }
      `}</style>
    </div> */}

            {/* <!-- About-Us-V2-Start --> */}
            <section className="about-us-v2-section wow animate__animated custom-fadeInUp" data-wow-delay="0.25s" data-wow-duration="2s">
                <div className="container">
                    <div className="about-us-v2">
                        <div className="about-us-content-block">
                            <h2 className="primary--heading">
                            Let Sri Engineering(Tool Room) take your business to new heights!

                            </h2>
                            <p>
                            Founded in 2001, Sri Engineering(Tool Room) has grown into a trusted name in engineering moulding and injection moulding solutions. Our commitment to quality, innovation, and customer satisfaction has positioned us as a leader in the industry.
                            </p>
                            <ul className="about-list">
                                <li className="list-item">
                                    <svg className="list-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path
                                            d="M368.8 119.8l-41.86-6.125l-18.72-38.09c-7.607-15.48-32.69-15.45-40.23 0L249.2 113.7L207.3 119.8C198.7 121.1 191.8 126.9 189.1 135.2C186.5 143.4 188.6 152.3 194.8 158.2l30.34 29.52L217.9 229.7C216.5 238.2 219.1 246.7 226.9 251.7c6.982 4.961 15.97 5.715 23.57 1.664l37.48-19.75l37.45 19.75C328.7 255.1 332.3 256 335.9 256c4.633 0 9.236-1.445 13.18-4.336c6.951-5.086 10.36-13.53 8.924-22.01l-7.201-41.89l30.34-29.52c6.199-6.027 8.391-14.86 5.729-23.11C384.2 126.9 377.3 121 368.8 119.8zM316.4 176.5L323.1 215.8L287.1 197.3L252.9 215.8l6.73-39.31L231.2 148.8l39.36-5.75l17.56-35.7l17.56 35.7l39.17 5.719L316.4 176.5zM572.2 76.72C570.7 69.31 564.1 64 556.6 64h-108.7c-.0137-6.172-.0496-12.01-.1805-17.34C447.1 20.5 425.1 0 399.7 0H176.3C150 0 128.9 20.5 128.3 46.66C128.1 51.99 128.1 57.83 128.1 64H19.43C11.87 64 5.336 69.31 3.773 76.72C2.898 80.91-17.19 180.8 45.04 272.8c41.67 61.64 109.9 104 202.5 126.7c14.29 3.5 24.43 16.23 24.43 30.95V480H176c-8.834 0-16.02 7.164-16.02 16S167.2 512 176 512H399.1c8.834 0 15.1-7.164 15.1-16S408.8 480 399.1 480h-95.97v-49.51c0-14.72 10.13-27.45 24.43-30.95c92.66-22.68 160.9-65.05 202.5-126.7C593.2 180.8 573.1 80.91 572.2 76.72zM71.79 255.3C29.2 192.6 30.55 123.8 33.33 96h95.38c3.016 77.71 19.29 188.6 81.19 258.1C148.4 332.9 101.9 299.6 71.79 255.3zM288 374.6C166.9 320.2 158.3 128.4 160.3 47.47C160.5 38.78 167.5 32 176.3 32h223.5c8.746 0 15.78 6.781 15.99 15.47C417.7 128.4 409.1 320.2 288 374.6zM504.2 255.3c-30.12 44.37-76.61 77.59-138.1 99.7C427.1 284.6 444.3 173.7 447.3 96h95.38C545.5 123.8 546.8 192.6 504.2 255.3z"
                                        ></path>
                                    </svg>
                                    <span className="list-title">Established as a tool room facility, expanding into injection moulding in 2003.</span
                                    >
                                </li>
                                <li className="list-item">
                                    <svg
                                        className="list-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path
                                            d="M364.2 267.2l-104.8-15.28L212.6 156.7C208.7 148.8 200.7 143.9 191.9 143.9C183.2 143.8 175.1 148.8 171.4 156.7L124.5 251.1L19.71 267.2C.9566 269.9-6.618 293.1 7.007 306.5l75.87 74l-17.1 104.6c-1.25 6.75 .5878 13.51 4.963 18.63C74.22 509 80.64 512 87.52 512c3.625 0 7.436-.9554 10.69-2.705l93.79-49.38l93.74 49.38c3.25 1.625 6.991 2.675 10.62 2.675c6.75 0 13.23-2.97 17.61-8.22c4.25-5.125 6.273-11.98 5.148-18.61L301.2 380.5l75.92-74C390.6 293 383.1 269.1 364.2 267.2zM266.7 369.3l17.62 103.1l-92.5-48.75l-92.5 48.75l17.62-103.1L42.22 296.1l103.4-15l46.38-93.88l46.13 93.88l103.5 15L266.7 369.3zM256 112h64v64C320 184.8 327.2 192 336 192S352 184.8 352 176v-64h64c8.844 0 16-7.156 16-16s-7.154-15.1-15.1-15.1L352 80v-64C352 7.156 344.8 0 336 0S320 7.156 320 16v64l-63.99 .0022C247.2 80 240 87.16 240 96S247.2 112 256 112zM496 208h-32v-32c0-8.844-7.155-15.1-15.1-15.1S432 167.2 432 176v32h-32c-8.844 0-15.1 7.162-15.1 16.01S391.2 240 400 240h32v32c0 8.844 7.158 16.01 16 16.01S464 280.8 464 272v-32h32c8.844 0 16-7.151 16-15.99S504.8 208 496 208z"
                                        ></path>
                                    </svg>
                                    <span className="list-title"
                                    >Achieved ISO 9001 certification in 2004, ensuring top-quality standards.</span
                                    >
                                </li>
                                <li className="list-item">
                                    <svg
                                        className="list-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path
                                            d="M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                                        ></path>
                                    </svg>
                                    <span className="list-title"
                                    >Continuously upgrading technology and adding new machines for enhanced efficiency.</span
                                    >
                                </li>
                            </ul>

                        </div>

                        <div class="about-img-block" >
            <img src="./assets/images_colored/m1.jpg" alt="" class="back-img" style={{height:'600px',border:"5px solid #ff7800",borderRadius:"10px"}}/>
            {/* <div class="upper-block">
              <img src="./assets/images_colored/i8.jpg" alt="" class="front-img"/>
              <div class="single-icon-box">
                <div class="content">
                  <span>Engineering excellence since 2001</span>
                </div>

                <div class="icon-inner">
                  <svg class="icon-svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="2324.238px" height="2560px" viewBox="0 0 2324.238 2560" xmlSpace="preserve">
                    <path d="M2241.326,2084.205l-424.13-419.36c277.722-147.582,467.85-442.82,467.85-782.328C2285.046,395.818,1894.936,0,1415.512,0 H555.051C248.939,0,0,252.695,0,563.264v1439.132c0,310.729,248.939,563.502,555.051,563.502h1107.133h384.168 C2293.961,2565.898,2417.689,2261.271,2241.326,2084.205z M569.598,169.324h845.914c387.45,0,702.635,319.955,702.635,713.192 c0,294.85-177.224,548.325-429.214,656.88L597.597,482.944C498.193,383.228,381.74,169.324,569.598,169.324z M555.051,2396.417 c-213.979,0-388.152-176.755-388.152-394.021v-665.875l1082.028,1059.896H555.051z M2046.352,2396.417h-557.165L166.899,1101.112 V563.264c0-125.996,59.36-239.71,151.178-311.82v0.155c-7.195,129.516,75.081,263.411,161.504,351.161l1644.354,1601.886 C2194.166,2275.113,2144.895,2396.417,2046.352,2396.417z"></path>
                  </svg>
                </div>
              </div>
            </div> */}
          </div>
                    </div>
                </div>
            </section>

            <div className="vm-outer-wrapper" style={{marginBottom:'80px'}}>
                <div className="vm-flex-container">
                    {/* Vision Section */}
                    <div className="vm-card">
                        <div className="vm-title-bar">
                            <h2>OUR VISION</h2>
                        </div>
                        <div className="vm-content-box">
                            <p>
                                TO MANUFACTURE ZERO DEFECT COMPONENTS WITH CONTROLLED MANUFACTURING PROCESS AND CONTINUOUS IMPROVEMENT IN QUALITY SYSTEMS
                            </p>
                        </div>
                    </div>

                    {/* Mission Section */}
                    <div className="vm-card">
                        <div className="vm-title-bar">
                            <h2>OUR MISSION</h2>
                        </div>
                        <div className="vm-content-box">
                            <p>
                                TO DELIVER HIGH-QUALITY PRODUCTS ON TIME, EXCEEDING CUSTOMER EXPECTATIONS THROUGH INNOVATION AND EXCELLENCE IN MANUFACTURING
                            </p>
                        </div>
                    </div>
                </div>

                <style>{`
        .vm-outer-wrapper {
          padding: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .vm-flex-container {
          display: flex;
          gap: 24px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .vm-card {
          flex: 1;
          min-width: 300px;
          max-width: 600px;
        }

        .vm-title-bar {
          background: linear-gradient(to right, #f59e0b, #ff7800);
          color: white;
          padding: 8px 16px;
          border-radius: 6px;
          width: fit-content;
          margin-bottom: 16px;
        }

        .vm-title-bar h2 {
          font-size: 20px;
          font-weight: bold;
          margin: 0;
        }

        .vm-content-box {
          background-color: #ff7800;
          padding: 22px;
          border-radius: 16px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          height: 100%;
          min-height: 200px;
          display: flex;
          align-items: center;
        }

        .vm-content-box p {
          color: white;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          line-height: 1.5;
          margin: 0;
        }

        @media (max-width: 768px) {
          .vm-flex-container {
            flex-direction: column;
          }
          
          .vm-card {
            width: 100%;
          }
        }
      `}</style>
            </div>
            {/* <!-- About-Us-V2-End --> */}
            <section className="work-v2-section">
                <div className="container">

                    <div className="work-content-block wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                        <div className="rodio-tabs tab-portrait">
                            <div className="rodio-tabs-inner">
                                {/* <!-- tab links - start --> */}

                                <ul className="nav nav-tabs" id="tab-container-0893aad" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="rodio-tab-08c64ea" data-value="rodio-tab-08c64ea" data-bs-toggle="tab" data-bs-target="#rodio-target-08c64ea" type="button" role="tab" aria-controls="rodio-target-08c64ea" aria-selected="true" data-selected="">
                                            <span className="icon-wrapper">
                                                <svg
                                                    className="icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                >
                                                    <path
                                                        d="M119.1 33.74l-64-31.1c-7.875-3.1-17.5-.875-21.38 7.125c-4 7.875-.875 17.5 7.125 21.37l64 31.1C107.1 63.36 109.5 63.99 112 63.99c7.375 0 13.88-5.125 15.62-12.37C129.3 44.49 125.8 36.99 119.1 33.74zM112 287.1c-2.5 0-4.875 .625-7.125 1.75l-64 31.1c-8 3.875-11.12 13.5-7.25 21.37c4 7.1 13.62 11.12 21.5 7.25l64-31.1c6.625-3.375 10.12-10.87 8.5-17.1C125.9 293.1 119.4 287.1 112 287.1zM528 63.99c2.5 0 4.875-.625 7.125-1.75l64-31.1c8-3.875 11.12-13.5 7.125-21.37c-3.875-7.1-13.5-11.12-21.38-7.125l-64 31.1c-6.625 3.25-10.12 10.75-8.5 17.87C514.1 58.86 520.6 63.99 528 63.99zM96 175.1C96 167.1 88.88 159.1 80 159.1h-64c-8.875 0-16 7.125-16 15.1S7.125 191.1 16 191.1h64C88.88 191.1 96 184.9 96 175.1zM624 159.1h-64c-8.875 0-16 7.125-16 15.1s7.125 15.1 16 15.1h64c8.875 0 16-7.125 16-15.1S632.9 159.1 624 159.1zM599.1 321.7l-64-31.1c-7.875-3.1-17.5-.75-21.5 7.125c-3.875 7.875-.75 17.5 7.25 21.5l64 31.1c7.875 3.875 17.5 .75 21.5-7.25C610.3 335.2 607.1 325.6 599.1 321.7zM319.5 .0154C222.7 .2967 144 79.89 144 177.4c0 42.91 15.47 84.34 43.55 116.6c13.33 15.31 35.84 49.59 43.73 76.02c1.078 8.687 8.844 14.62 17.64 13.71c8.703-.9687 14.98-8.965 14.11-17.65l-.6094-3.312c-10.31-34.97-36-72.84-50.73-89.77C188.7 246.5 176 212.6 176 177.4c0-81.24 63.05-145.1 143.5-145.3H320c38.13 0 74.05 14.87 101.2 41.94C448.8 101.5 464 138.2 464 177.4c0 35.19-12.67 69.15-35.67 95.62c-14.75 16.94-40.44 54.8-50.75 89.77l-.625 3.344c-1.047 8.75 4.938 17.59 13.67 18.68c.7813 .0938 1.531 .1562 2.281 .1562c7.797 0 14.36-5.121 15.36-13.12c8.344-28.25 30.86-62.53 44.2-77.84C480.5 261.7 496 220.3 496 177.4c0-47.71-18.55-92.49-52.22-126.1C410.5 18.08 365.6-1.172 319.5 .0154zM383.1 415.1H256c-8.846 0-16.01 7.18-16 16.03l.0746 22.34c.0098 6.27 1.884 12.46 5.359 17.68l17.09 25.69c5.225 7.855 17.22 14.28 26.65 14.28h61.72c9.418 0 21.41-6.43 26.63-14.27l17.09-25.69c2.953-4.441 5.351-12.36 5.359-17.68l-.0254-22.34C399.1 423.2 392.8 415.1 383.1 415.1zM367.9 454.4l-16.11 24.45c-.4766 .4375-1.686 1.086-.8672 1.117l-60.29 .1172c-.4238-.1016-1.138-.2773-1.423-.2773c-.1406 0-.1348-.2266 0 0l-17.1-25.48l-.0098-6.367h95.94l.0039 5.18C367.9 453.6 367.7 454.4 367.9 454.4C367.9 454.4 367.8 454.5 367.9 454.4zM336 80.02c0-8.84-7.156-16-16-16c-61.75 0-112 50.24-112 111.1c0 8.844 7.156 16 16 16s16-7.159 16-16c0-44.1 35.88-79.1 80-79.1C328.8 96.01 336 88.86 336 80.02z"
                                                    ></path>
                                                </svg>
                                            </span>
                                            <span className="button-list-text">Engineering Excellence</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="rodio-tab-609bd78" data-value="rodio-tab-609bd78" data-bs-toggle="tab" data-bs-target="#rodio-target-609bd78" type="button" role="tab" aria-controls="rodio-target-609bd78" aria-selected="false">
                                            <span className="icon-wrapper">
                                                <svg
                                                    className="icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                >
                                                    <path
                                                        d="M64 240c-28.28 0-64 21.84-64 64c0 35.25 28.75 64 64 64s64-28.75 64-64C128 262.1 92.68 240 64 240zM64 336c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.63 336 64 336zM184 288H167.1C159.2 288 152 295.2 152 303.1S159.2 320 167.1 320h16.05C192.8 320 200 312.8 200 304S192.8 288 184 288zM576 192c28.28 0 64-21.84 64-64c0-42.01-35.62-64-64-64c-28.28 0-64 21.84-64 64C512 163.3 540.8 192 576 192zM576 96c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S558.4 96 576 96zM576 384c-13.25 0-25.62 4-35.75 10.88c-3.375 2.25-6.375 4.75-9.125 7.5l-91.88-55.13C444.9 334 448 319.3 448 304C448 242.1 397.9 192 336 192c-11.25 0-21.88 2.25-32.25 5.25L264.5 113.1C278.8 101.4 288 83.88 288 64c0-41.93-35.32-64-64-64C182.1 0 160 35.31 160 64c0 35.25 28.75 64 64 64c4 0 7.875-.5 11.75-1.25l39 83.63C244.3 230.4 224 264.8 224 304c0 61.88 50.13 112 112 112c35 0 65.75-16.38 86.38-41.5l92.38 55.38C513.1 435.8 512 441.8 512 448c0 35.25 28.62 64 64 64C618.2 512 640 476.4 640 448C640 420.5 618.4 384 576 384zM224 96C206.4 96 192 81.63 192 64s14.38-32 32-32s32 14.38 32 32S241.6 96 224 96zM336 384C291.9 384 256 348.1 256 304S291.9 224 336 224S416 259.9 416 304S380.1 384 336 384zM576 480c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S593.6 480 576 480zM478.4 229.2l22.44-16.83c7.074-5.307 8.492-15.35 3.166-22.41c-5.305-7.025-15.29-8.436-22.34-3.154l-22.44 16.83c-7.074 5.305-8.492 15.35-3.166 22.4C461.3 233.1 471.3 234.5 478.4 229.2z"
                                                    ></path>
                                                </svg>
                                            </span>
                                            <span className="button-list-text"> Growth</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="rodio-tab-50ee308" data-value="rodio-tab-50ee308" data-bs-toggle="tab" data-bs-target="#rodio-target-50ee308" type="button" role="tab" aria-controls="rodio-target-50ee308" aria-selected="false">
                                            <span className="icon-wrapper">
                                                <svg
                                                    className="icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                >
                                                    <path
                                                        d="M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM319.9 144c39.68 0 71.96 32.3 71.96 72S359.5 288 319.9 288S247.9 255.7 247.9 216S280.2 144 319.9 144zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM160.2 480c3.021-53.41 51.19-96 109.1-96H369.9c58.78 0 106.9 42.59 109.1 96H160.2zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM512 32c26.47 0 48 21.53 48 48S538.5 128 512 128s-48-21.53-48-48S485.5 32 512 32zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM128 32c26.47 0 48 21.53 48 48S154.5 128 128 128S80 106.5 80 80S101.5 32 128 32zM561.1 192H496c-11.16 0-22.08 2.5-32.47 7.438c-7.984 3.797-11.39 13.34-7.594 21.31s13.38 11.39 21.31 7.594C483.3 225.5 489.6 224 496 224h65.08C586.1 224 608 246.7 608 274.7V288c0 8.844 7.156 16 16 16S640 296.8 640 288V274.7C640 229.1 604.6 192 561.1 192zM162.8 228.3c7.938 3.797 17.53 .375 21.31-7.594c3.797-7.969 .3906-17.52-7.594-21.31C166.1 194.5 155.2 192 144 192H78.92C35.41 192 0 229.1 0 274.7V288c0 8.844 7.156 16 16 16S32 296.8 32 288V274.7C32 246.7 53.05 224 78.92 224H144C150.4 224 156.7 225.5 162.8 228.3z"
                                                    ></path>
                                                </svg>
                                            </span>
                                            <span className="button-list-text"> Innovation</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="rodio-tab-910816c" data-value="rodio-tab-910816c" data-bs-toggle="tab" data-bs-target="#rodio-target-910816c" type="button" role="tab" aria-controls="rodio-target-910816c" aria-selected="false">
                                            <span className="icon-wrapper">
                                                <svg
                                                    className="icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                >
                                                    <path
                                                        d="M367.1 88c-30.87 0-55.1 25.12-55.1 56c0 31 25.12 56 55.1 56c30.1 0 55.1-25 55.1-56C423.1 113.1 398.1 88 367.1 88zM367.1 168c-13.25 0-23.1-10.75-23.1-24s10.75-24 23.1-24c13.25 0 23.1 10.75 23.1 24S381.2 168 367.1 168zM505.1 19.25c-1.125-5.375-6.1-11.25-12.37-12.37C460.6 0 435.4 0 410.4 0c-103.2 0-165 55.25-211.3 128H94.92C78.67 128 59.3 139.9 52.05 154.5L2.65 253.2C1.15 256.6 .225 260.2 .1 264c0 13.25 10.8 24 24.05 24h103.9c52.1 0 95.99 43 95.99 96l-.0125 104c0 13.25 10.75 24 23.1 24c3.75-.125 7.375-.925 10.75-2.55l98.69-49.38c14.62-7.25 26.5-26.58 26.5-42.83V312.8c72.62-46.25 127.1-108.4 127.1-211C512.1 76.5 512.1 51.38 505.1 19.25zM37.12 256l43.62-87.25C82.62 165.1 90.87 160 94.99 160h85.12C166.1 188 148.4 224 132.5 256l.125 .375C131.1 256.4 60.1 256 37.12 256zM351.1 417.2c0 4.125-5.125 12.38-8.75 14.13L256.1 475c0-23.88-.3749-94-.5-95.63L255.1 379.5c31.1-15.88 67.87-33.63 95.87-47.63L351.1 417.2zM249.9 346.6C237.5 306.2 205.7 274.5 165.2 262.1C217.4 158.1 264.1 32 410.5 32c21.12 0 41.25 0 65.37 4.125c4.25 24.38 4.125 44.5 4.125 65.63C479.1 246.6 352.1 295.1 249.9 346.6zM102.4 320c-47.1 0-100.4 39.38-102.2 160L0 512h31.1c171.6-3.375 184.9-115.2 133.7-166.6C150.9 330.4 127.2 320 102.4 320zM155.4 429.4c-12.87 31.12-57.62 49.38-123.4 50.5C31.1 476.4 30.87 352 102.4 352c15.12 0 31.12 6.375 40.87 16.12C155.1 381 164.6 406.8 155.4 429.4z"
                                                    ></path>
                                                </svg>
                                            </span>
                                            <span className="button-list-text"> Sustainability</span>
                                        </button>
                                    </li>
                                </ul>

                                {/* <!-- tab links - end -->
                        <!-- tab panes - start --> */}

                                <div className="tab-content">
                                    <div className="tab-pane active first-render elementor-repeater-item-08c64ea tab-text" id="rodio-target-08c64ea" role="tabpanel" aria-labelledby="rodio-tab-08c64ea">
                                        <div className="tab-pane-inner text-pane">
                                            <h3>Our Strategy</h3>
                                            <div>
                                                <p style={{color:'#fff'}}>
                                                At Sri Engineering(Tool Room), we specialize in engineering moulding and injection moulding, delivering high-precision solutions to industries worldwide

                                                </p>
                                                <p style={{color:'#fff'}}>
                                                   
                                                Our commitment to quality, innovation, and advanced manufacturing techniques ensures durable and efficient moulding solutions for a variety of applications.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>

                                {/* <!-- tab panes - end --> */}
                            </div>
                        </div>
                        <div className="accordion" id="accordion-parent">
                            <div className="accordion-item shown">
                                <h2 className="accordion-header" id="accordion-heading-1">
                                    <button className="accordion-button keep-open" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-1" aria-expanded="true" aria-controls="accordion-collapse-1">
                                        <span> What makes us unique?</span>
                                        <span className="icon"></span>
                                    </button>
                                </h2>
                                <div id="accordion-collapse-1" className="accordion-collapse collapse show" aria-labelledby="accordion-heading-1" data-bs-parent="#accordion-parent">
                                    <div className="accordion-body">
                                        <p>
                                        Decades of expertise in precision engineering, serving top industries.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="accordion-heading-2">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-2" aria-expanded="false" aria-controls="accordion-collapse-2">
                                        <span> How do we ensure quality?</span>
                                        <span className="icon"></span>
                                    </button>
                                </h2>
                                <div id="accordion-collapse-2" className="accordion-collapse collapse" aria-labelledby="accordion-heading-2" data-bs-parent="#accordion-parent">
                                    <div className="accordion-body">
                                        <p>
                                        State-of-the-art facilities, stringent testing, and customer-driven solutions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="accordion-heading-3">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-3" aria-expanded="false" aria-controls="accordion-collapse-3">
                                        <span>How to get started?</span>
                                        <span className="icon"></span>
                                    </button>
                                </h2>
                                <div id="accordion-collapse-3" className="accordion-collapse collapse" aria-labelledby="accordion-heading-3" data-bs-parent="#accordion-parent">
                                    <div className="accordion-body">
                                        <p>
                                        Contact us today for tailored solutions to meet your business needs!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Clients-Section-Start --> */}
            <section className="testimonial-section">
                <div className="container">
                    {/* <div className="slider-header wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                <h2 className="primary--heading">.</h2>
                <div className="client-slider-btns">
                    <div className="testi-button-prev slider-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path
                  d="M203.9 405.3c5.877 6.594 5.361 16.69-1.188 22.62c-6.562 5.906-16.69 5.375-22.59-1.188L36.1 266.7c-5.469-6.125-5.469-15.31 0-21.44l144-159.1c5.906-6.562 16.03-7.094 22.59-1.188c6.918 6.271 6.783 16.39 1.188 22.62L69.53 256L203.9 405.3z"
                ></path>
              </svg>
                    </div>
                    <div className="testi-button-next slider-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                <path
                  d="M219.9 266.7L75.89 426.7c-5.906 6.562-16.03 7.094-22.59 1.188c-6.918-6.271-6.783-16.39-1.188-22.62L186.5 256L52.11 106.7C46.23 100.1 46.75 90.04 53.29 84.1C59.86 78.2 69.98 78.73 75.89 85.29l144 159.1C225.4 251.4 225.4 260.6 219.9 266.7z"
                ></path>
              </svg>
                    </div>
                </div>
            </div> */}

                    {/* <div className="swiper testimonial-swiper wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="testimonial-slide">
                            <div className="image">
                                <img src="./assets/images_colored/testi-img-1.jpg" alt="" className="testi-img"/>
                            </div>
                            <div className="content">
                                <div className="content-wrapper">
                                    <p>
                                        “Sea abundantly multiply has greater open doesn't they are over you're you'll may there blessed over forth bring fill by was earth may behold night greater their called.”
                                    </p>
                                </div>
                                <div className="details">
                                    <h5>Kevin Brown</h5>
                                    <h6>GOOGLE</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="testimonial-slide">
                            <div className="image">
                                <img src="./assets/images_colored/testi-img-2.jpg" alt="" className="testi-img"/>
                            </div>
                            <div className="content">
                                <div className="content-wrapper">
                                    <p>
                                        “Sea abundantly multiply has greater open doesn't they are over you're you'll may there blessed over forth bring fill by was earth may behold night greater their called.”
                                    </p>
                                </div>
                                <div className="details">
                                    <h5>Jessica Kale</h5>
                                    <h6>Envato</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="testimonial-slide">
                            <div className="image">
                                <img src="./assets/images_colored/testi-img-3.jpg" alt="" className="testi-img"/>
                            </div>
                            <div className="content">
                                <div className="content-wrapper">
                                    <p>
                                        “Sea abundantly multiply has greater open doesn't they are over you're you'll may there blessed over forth bring fill by was earth may behold night greater their called.”
                                    </p>
                                </div>
                                <div className="details">
                                    <h5>Sophie Kelly</h5>
                                    <h6>Shopify</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="testimonial-slide">
                            <div className="image">
                                <img src="./assets/images_colored/testi-img-4.jpg" alt="" className="testi-img"/>
                            </div>
                            <div className="content">
                                <div className="content-wrapper">
                                    <p>
                                        “Sea abundantly multiply has greater open doesn't they are over you're you'll may there blessed over forth bring fill by was earth may behold night greater their called.”
                                    </p>
                                </div>
                                <div className="details">
                                    <h5>William Martin</h5>
                                    <h6>Shopify</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="testimonial-slide">
                            <div className="image">
                                <img src="./assets/images_colored/testi-img-5.jpg" alt="" className="testi-img"/>
                            </div>
                            <div className="content">
                                <div className="content-wrapper">
                                    <p>
                                        “Sea abundantly multiply has greater open doesn't they are over you're you'll may there blessed over forth bring fill by was earth may behold night greater their called.”
                                    </p>
                                </div>
                                <div className="details">
                                    <h5>Jake Anderson</h5>
                                    <h6>Shopify</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="testimonial-slide">
                            <div className="image">
                                <img src="./assets/images_colored/testi-img-6.jpg" alt="" className="testi-img"/>
                            </div>
                            <div className="content">
                                <div className="content-wrapper">
                                    <p>
                                        “Sea abundantly multiply has greater open doesn't they are over you're you'll may there blessed over forth bring fill by was earth may behold night greater their called.”
                                    </p>
                                </div>
                                <div className="details">
                                    <h5>Britteny Mac</h5>
                                    <h6>Shopify</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
                </div>
            </section>
            {/* <!-- Clients-Section-End --> */}


            {/* <!-- About-Us-V3-Start --> */}
            <section className="about-us-v3-section">
                <div className="home-1-fact-section r-left-align">
                    <section className="facts-section elementor-container">
                        <div className="container">
                            <div className="icon-box">
                                <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                    <path
                                        d="M119.1 33.74l-64-31.1c-7.875-3.1-17.5-.875-21.38 7.125c-4 7.875-.875 17.5 7.125 21.37l64 31.1C107.1 63.36 109.5 63.99 112 63.99c7.375 0 13.88-5.125 15.62-12.37C129.3 44.49 125.8 36.99 119.1 33.74zM112 287.1c-2.5 0-4.875 .625-7.125 1.75l-64 31.1c-8 3.875-11.12 13.5-7.25 21.37c4 7.1 13.62 11.12 21.5 7.25l64-31.1c6.625-3.375 10.12-10.87 8.5-17.1C125.9 293.1 119.4 287.1 112 287.1zM528 63.99c2.5 0 4.875-.625 7.125-1.75l64-31.1c8-3.875 11.12-13.5 7.125-21.37c-3.875-7.1-13.5-11.12-21.38-7.125l-64 31.1c-6.625 3.25-10.12 10.75-8.5 17.87C514.1 58.86 520.6 63.99 528 63.99zM96 175.1C96 167.1 88.88 159.1 80 159.1h-64c-8.875 0-16 7.125-16 15.1S7.125 191.1 16 191.1h64C88.88 191.1 96 184.9 96 175.1zM624 159.1h-64c-8.875 0-16 7.125-16 15.1s7.125 15.1 16 15.1h64c8.875 0 16-7.125 16-15.1S632.9 159.1 624 159.1zM599.1 321.7l-64-31.1c-7.875-3.1-17.5-.75-21.5 7.125c-3.875 7.875-.75 17.5 7.25 21.5l64 31.1c7.875 3.875 17.5 .75 21.5-7.25C610.3 335.2 607.1 325.6 599.1 321.7zM319.5 .0154C222.7 .2967 144 79.89 144 177.4c0 42.91 15.47 84.34 43.55 116.6c13.33 15.31 35.84 49.59 43.73 76.02c1.078 8.687 8.844 14.62 17.64 13.71c8.703-.9687 14.98-8.965 14.11-17.65l-.6094-3.312c-10.31-34.97-36-72.84-50.73-89.77C188.7 246.5 176 212.6 176 177.4c0-81.24 63.05-145.1 143.5-145.3H320c38.13 0 74.05 14.87 101.2 41.94C448.8 101.5 464 138.2 464 177.4c0 35.19-12.67 69.15-35.67 95.62c-14.75 16.94-40.44 54.8-50.75 89.77l-.625 3.344c-1.047 8.75 4.938 17.59 13.67 18.68c.7813 .0938 1.531 .1562 2.281 .1562c7.797 0 14.36-5.121 15.36-13.12c8.344-28.25 30.86-62.53 44.2-77.84C480.5 261.7 496 220.3 496 177.4c0-47.71-18.55-92.49-52.22-126.1C410.5 18.08 365.6-1.172 319.5 .0154zM383.1 415.1H256c-8.846 0-16.01 7.18-16 16.03l.0746 22.34c.0098 6.27 1.884 12.46 5.359 17.68l17.09 25.69c5.225 7.855 17.22 14.28 26.65 14.28h61.72c9.418 0 21.41-6.43 26.63-14.27l17.09-25.69c2.953-4.441 5.351-12.36 5.359-17.68l-.0254-22.34C399.1 423.2 392.8 415.1 383.1 415.1zM367.9 454.4l-16.11 24.45c-.4766 .4375-1.686 1.086-.8672 1.117l-60.29 .1172c-.4238-.1016-1.138-.2773-1.423-.2773c-.1406 0-.1348-.2266 0 0l-17.1-25.48l-.0098-6.367h95.94l.0039 5.18C367.9 453.6 367.7 454.4 367.9 454.4C367.9 454.4 367.8 454.5 367.9 454.4zM336 80.02c0-8.84-7.156-16-16-16c-61.75 0-112 50.24-112 111.1c0 8.844 7.156 16 16 16s16-7.159 16-16c0-44.1 35.88-79.1 80-79.1C328.8 96.01 336 88.86 336 80.02z"
                                    ></path>
                                </svg>
                            </div>
                            <h2 className="primary--heading">Key Achievements</h2>
                            <div className="facts-cards-wrapper wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                                <div className="facts-card">
                                    <div className="img-block">
                                        <img src="./assets/images_colored/i7.jpg" alt="" className="fact-img" />
                                    </div>
                                    <div className="icon-card">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                            <path
                                                d="M564 288h-40c-15.18 0-29.27 4.83-41.15 12.93 9.38 6.37 17.93 13.87 25.45 22.37 4.89-2.05 10.15-3.3 15.7-3.3h40c24.25 0 44 21.53 44 48 0 8.84 7.16 16 16 16s16-7.16 16-16c0-44.11-34.09-80-76-80zm-20-32c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-128c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zM400.15 308.02c-11.88 0-23.87 1.73-35.49 5.26-14.16 4.3-29.1 6.72-44.66 6.72s-30.5-2.42-44.66-6.71a122.209 122.209 0 0 0-35.49-5.26c-36.29 0-71.58 16.18-92.28 46.93C135.21 373.3 128 395.41 128 419.2V432c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-12.8c0-23.79-7.21-45.9-19.57-64.25-20.7-30.75-56-46.93-92.28-46.93zM480 432c0 8.82-7.18 16-16 16H176c-8.82 0-16-7.18-16-16v-12.8c0-16.63 4.88-32.67 14.11-46.38 13.83-20.54 38.4-32.8 65.74-32.8 8.9 0 17.71 1.31 26.19 3.88 17.69 5.37 35.84 8.1 53.96 8.1s36.27-2.72 53.96-8.1a89.887 89.887 0 0 1 26.19-3.88c27.34 0 51.91 12.26 65.74 32.8 9.23 13.71 14.11 29.75 14.11 46.38V432zM96 256c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-128c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zm61.15 172.93C145.27 292.83 131.18 288 116 288H76c-41.91 0-76 35.89-76 80 0 8.84 7.16 16 16 16s16-7.16 16-16c0-26.47 19.75-48 44-48h40c5.55 0 10.81 1.25 15.7 3.3 7.52-8.5 16.07-16 25.45-22.37zM320 288c61.86 0 112-50.14 112-112V32l-56 28-56-28-56 28-56-28v144c0 61.86 50.14 112 112 112zM240 83.78l24 12 56-28 56 28 24-12V128H240V83.78zm0 76.22h160v16c0 44.11-35.89 80-80 80s-80-35.89-80-80v-16z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div className="number-title-wrapper">
                                        <div className="counter-number" data-count="2215">150+</div>
                                        <div className="title">Happy Clients</div>
                                    </div>
                                </div>
                                <div className="facts-card">
                                    <div className="img-block">
                                        <img src="./assets/images_colored/i6.png" alt="" className="fact-img" />
                                    </div>
                                    <div className="icon-card">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                            <path
                                                d="M528 0H48C21.5 0 0 21.5 0 48v288c0 26.5 21.5 48 48 48h192l-24 96h-72c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-72l-24-96h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM249 480l16-64h46l16 64h-78zm295-144c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v288z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div className="number-title-wrapper">
                                        <div className="counter-number" data-count="1368">500+</div>
                                        <div className="title">Moulds Manufactured</div>
                                    </div>
                                </div>
                                <div className="facts-card">
                                    <div className="img-block">
                                        <img src="./assets/images_colored/m41.jpg" alt="" className="fact-img" />
                                    </div>
                                    <div className="icon-card">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                                            <path
                                                d="M248 8C111.04 8 0 119.03 0 256s111.04 248 248 248 248-111.03 248-248S384.96 8 248 8zm193.21 152H423.5c-17.38 0-31.5 14.12-31.5 31.5l.28 6.47-12.62 6.69c-2.66.48-8.41.66-15.09.97-32.31 1.52-46.88 2.67-52.91 14.61l-4 10.12 18.44 27.61A31.427 31.427 0 0 0 352.29 272l7.72-.5.09 11.02-18.81 25.09a31.937 31.937 0 0 0-5.66 12.97l-4.19 22.56c-10.38 9.5-19.62 20.3-27.47 32.08l-13.03 19.53c-4.66 6.98-16.53 6.33-20.28-1.28a62.926 62.926 0 0 1-6.66-28.09V335.5c0-17.38-14.12-31.5-31.5-31.5h-25.88c-10.31 0-20-4.02-27.31-11.31-7.28-7.3-11.31-17-11.31-27.31v-14.06c0-12.09 5.78-23.66 15.44-30.91l27.62-20.69c10.94-8.27 27.72-10.42 41.31-3.64l14.72 7.36c7.5 3.73 16.03 4.38 24.06 1.7l47.31-15.77a31.466 31.466 0 0 0 21.53-29.88c0-17.38-14.12-31.5-31.5-31.5l-9.72.16-6.94-6.94c-5.94-5.94-13.84-9.22-22.25-9.22l-89.58.51-.38-3.92 14.44-3.61c7.66-1.91 14.25-6.56 18.56-13.06L240.28 80h24.22c17.38 0 31.5-14.12 31.5-31.5v-2.94C359.74 60.1 412.7 102.86 441.21 160zM248 472c-119.1 0-216-96.9-216-216S128.9 40 248 40c5.54 0 10.96.42 16.39.83l.11 7.17h-24.22c-10.53 0-20.34 5.25-26.19 14.02l-7.78 11.92-14.47 3.61C177.81 81.08 168 93.64 168 108.09v4.41c0 17.38 14.12 31.5 31.5 31.5l89.72-.16 6.94 6.94c5.94 5.95 13.84 9.22 22.25 9.22l9.94-.97-46.94 15.78-14.72-7.36c-22.34-11.17-53.38-9.5-74.84 6.67l-27.59 20.69c-17.7 13.27-28.26 34.39-28.26 56.5v14.06c0 18.86 7.34 36.59 20.69 49.94S187.75 336 206.62 336l25.38-.5v29.88c0 14.69 3.47 29.38 10.03 42.42 7.44 14.92 22.44 24.2 39.12 24.2 14.66 0 28.25-7.28 36.41-19.48l13.03-19.55c6.44-9.64 14-18.47 22.41-26.17 5.09-4.62 8.47-10.66 9.75-17.45l4.22-22.62 18.75-25c4.06-5.42 6.28-12.12 6.28-18.89V271.5c0-17.38-14.12-31.5-31.5-31.5l-7.78.2-1.22-1.83c5.38-.34 10.81-.61 14.53-.78 15.88-.73 20.66-1.05 25.16-3.3l15.41-7.7c10.75-5.38 17.41-16.17 17.41-28.17l-.5-6.42h30.81c6.29 20.23 9.69 41.73 9.69 64C464 375.1 367.1 472 248 472z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div className="number-title-wrapper">
                                        <div className="counter-number" data-count="2215">100+</div>
                                        <div className="title"> Industries Served</div>
                                    </div>
                                </div>
                                <div className="facts-card">
                                    <div className="img-block">
                                        <img src="./assets/images_colored/m2.jpg" alt="" className="fact-img" />
                                    </div>
                                    <div className="icon-card">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                                            <path
                                                d="M305.05 98.74l23.96 53.62-92.33 92.33c-6.25 6.25-6.25 16.38 0 22.62 3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l92.33-92.33 53.62 23.96a20.547 20.547 0 0 0 21.04-4.96l63.67-63.67c10.8-10.8 6.46-29.2-8.04-34.04l-55.66-18.55-18.55-55.65C404.73 13.08 396.54 8 388.16 8c-5.14 0-10.36 1.92-14.47 6.03L310.02 77.7a20.582 20.582 0 0 0-4.97 21.04zm78.18-48.99l12.7 38.09 5.06 15.18 15.18 5.06 38.09 12.7-44.93 44.93-49.09-21.93-21.93-49.09 44.92-44.94zm101.2 131.35l-26.18 26.18c3.63 15.69 5.75 31.95 5.75 48.72 0 119.1-96.9 216-216 216S32 375.1 32 256 128.9 40 248 40c16.78 0 33.04 2.11 48.72 5.75l26.18-26.18A247.848 247.848 0 0 0 248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248c0-26.11-4.09-51.26-11.57-74.9zM274.7 108.85a53.056 53.056 0 0 1-2.68-14.44C264.12 93.25 256.23 92 248 92c-90.65 0-164 73.36-164 164 0 90.65 73.36 164 164 164 90.65 0 164-73.36 164-164 0-8.35-1.25-16.35-2.45-24.36-4.89-.21-9.76-.79-14.41-2.34-2.12-.71 1.02.62-20.69-9.07C377.7 231.68 380 243.52 380 256c0 72.79-59.21 132-132 132s-132-59.21-132-132 59.21-132 132-132c12.48 0 24.32 2.3 35.77 5.55-9.69-21.7-8.36-18.56-9.07-20.7zM248 176c-44.11 0-80 35.89-80 80s35.89 80 80 80 80-35.89 80-80c0-3.77-.61-7.38-1.11-11.01l-44.95 44.95-.01-.01c-8.7 8.69-20.7 14.07-33.93 14.07-26.47 0-48-21.53-48-48 0-13.23 5.38-25.23 14.07-33.93l-.01-.01 44.95-44.95c-3.63-.5-7.24-1.11-11.01-1.11z"
                                            ></path>
                                        </svg>
                                    </div>
                                    <div className="number-title-wrapper">
                                        <div className="counter-number" data-count="1364">23+ (Since 2001)</div>
                                        <div className="title">Years of Excellence</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div className="container">
                    <div className="about-us-v3 wow animate__animated custom-fadeInUp" data-wow-duration="2s">
                        <div className="about-img-block">
                            <div data-extend="left" className="r-image overlap">
                                <div className="r-image-inner responive_naya_image_aboutus">
                                    {/* <img src="./assets/images_colored/wp1.jpg" alt="About-img" /> */}
                                    <img src="./assets/images_colored/injc.png" alt="About-img"  style={{border:"5px solid #ffffff",borderRadius:"10px"}}/>
                                </div>
                            </div>
                        </div>

                        <div className="about-us-content-block">
                            <h2 className="primary--heading">
                            A Workplace Built for Excellence
                            </h2>
                            <p style={{color:'#fff'}}>
                            At Sri Engineering(Tool Room), we lead the way in engineering moulding and injection moulding, delivering high-performance components that empower industries. Our foundation is built on innovation, expertise, and cutting-edge technology, ensuring precision-driven manufacturing solutions that meet evolving industry demands.
                            </p>
                            <ul className="about-list">
                                <li className="list-item">
                                    <svg className="list-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path
                                            d="M480.1 159c-9.375-9.375-24.56-9.375-33.94 0L192 414.1L64.97 287c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l144 144C179.7 469.7 185.8 472 192 472s12.28-2.344 16.97-7.031l272-272C490.3 183.6 490.3 168.4 480.1 159zM175 240.1C179.7 245.7 185.8 248 192 248s12.28-2.344 16.97-7.031l176-176c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L192 190.1L112.1 111c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L175 240.1z"
                                        ></path>
                                    </svg>
                                    <span className="list-title">Engineering moulds designed with innovation.</span
                                    >
                                </li>
                                <li className="list-item">
                                    <svg
                                        className="list-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path
                                            d="M480.1 159c-9.375-9.375-24.56-9.375-33.94 0L192 414.1L64.97 287c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l144 144C179.7 469.7 185.8 472 192 472s12.28-2.344 16.97-7.031l272-272C490.3 183.6 490.3 168.4 480.1 159zM175 240.1C179.7 245.7 185.8 248 192 248s12.28-2.344 16.97-7.031l176-176c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L192 190.1L112.1 111c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L175 240.1z"
                                        ></path>
                                    </svg>
                                    <span className="list-title"
                                    >Advancing moulding technology to redefine the future of engineering.</span
                                    >
                                </li>
                                <li className="list-item">
                                    <svg
                                        className="list-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path
                                            d="M480.1 159c-9.375-9.375-24.56-9.375-33.94 0L192 414.1L64.97 287c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l144 144C179.7 469.7 185.8 472 192 472s12.28-2.344 16.97-7.031l272-272C490.3 183.6 490.3 168.4 480.1 159zM175 240.1C179.7 245.7 185.8 248 192 248s12.28-2.344 16.97-7.031l176-176c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L192 190.1L112.1 111c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L175 240.1z"
                                        ></path>
                                    </svg>
                                    <span className="list-title">Commitment to quality, efficiency, and industry-leading expertise.</span>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- About-Us-V3-End -->
            <div style={styles.container1}>
                <div style={styles.header1}>
                    <h1 style={styles.title1}>Organizational Structure</h1>
                </div>
                <div className="image-hov-one" style={styles.imageContainer}>
                    <img className="img-fluid" src="./assets/images_colored/tree.jpg" alt="..." style={styles.imageStyle} />
                </div>
            </div> */}
            <Milestones />
            {/* <Iso /> */}
            <div className="back-to-top">
        <div className="back-to-top-inner">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path
              d="M363.9 330.7c-6.271 6.918-16.39 6.783-22.62 1.188L192 197.5l-149.3 134.4c-6.594 5.877-16.69 5.361-22.62-1.188C14.2 324.1 14.73 314 21.29 308.1l159.1-144c6.125-5.469 15.31-5.469 21.44 0l159.1 144C369.3 314 369.8 324.1 363.9 330.7z"
            ></path>
          </svg>
        </div>
      </div>
        </div>
    )
}

export default About



